// extracted by mini-css-extract-plugin
export default {"container":"MoneyRain_container__-sJRS","particle":"MoneyRain_particle__dRmKT","fall":"MoneyRain_fall__XkDjv"};